import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ReportTypes } from "./reports.enum";
import { DropdownValue } from "../shared/dropdown.model";
import { FilterItemsService } from "../shared/filter-items.service";
import { IRecentSavedReportModel } from "./recent-saved-reports/recent-saved-report.model";
import { BrowserService } from "../core/services/browser.service";
import { consts } from "../shared/consts";
import { DateHelperService } from "../core/services/index";
import { DropdownComponent } from "../index";
import { ClaimsService } from "../core/services/claims.service";

@Component({
    moduleId: module.id,
    templateUrl: 'reports.component.html'
})

export class ReportsComponent implements OnInit {
    reportSelected: boolean = false;
    reportTypes: typeof ReportTypes = ReportTypes;
    selectedType: number;
    periodPrefix: string = "Period";
    periodValues: Array<DropdownValue> = [];
    defaultPeriodSelection: DropdownValue;
    showReport: boolean = false;
    startDate: Date;
    endDate: Date;
    filterStartDate: Date;
    filterEndDate: Date;
    showCustomPeriod: boolean = false;
    fileName: string;
    period: DropdownValue;
    toMaxDate: Date = new Date();
    dateError: string;
    private readonly customValue: number = 9;
    showAdminReport: boolean = false;

    @ViewChild("dateSelector") dropdownComponent: DropdownComponent;

    constructor(
        private filterItemsService: FilterItemsService,
        private el: ElementRef,
        private browserSerive: BrowserService,
        private dateHelperService: DateHelperService,
        private claimsService: ClaimsService) { }

    ngOnInit() {
        this.periodValues = this.filterItemsService.getPeriods();
        this.periodValues.shift();
        this.defaultPeriodSelection = this.filterItemsService.getDefaultPeriodSelection();
        this.startDate = this.filterItemsService.getMinValueSelected(this.defaultPeriodSelection.value);
        this.endDate = this.filterItemsService.getMaxValueSelected(this.defaultPeriodSelection.value);
        this.period = this.defaultPeriodSelection;
        this.dropdownComponent.setCurrentSelection(this.period);
        //set dates for selected period in datepickers
        this.setDateInDatePicker();

        this.showAdminReport = this.claimsService.getUserTypeId() === 1;
    }

    selectReport(type: number) {
        if (type != ReportTypes.InternalFill && type != ReportTypes.Requests) {
            this.resetDatePickers();
            this.reportSelected = true;
            this.selectedType = type;
            this.showReport = false;
            this.defaultPeriodSelection = this.filterItemsService.getDefaultPeriodSelection();
            this.startDate = this.filterItemsService.getMinValueSelected(this.defaultPeriodSelection.value);
            this.endDate = this.filterItemsService.getMaxValueSelected(this.defaultPeriodSelection.value);
            this.dropdownComponent.setCurrentSelection(this.defaultPeriodSelection);
            //set dates for selected period in datepickers
            this.setDateInDatePicker();
        }
    }

    onFilter() {
        if (this.showCustomPeriod) {
            if (!this.startDate || !this.endDate) {
                this.dateError = 'Please select from and to date!';
                return;
            }
            if (this.startDate > this.endDate) {
                this.dateError = consts.StartDateGreaterThanEndDateText;
                return;
            }
            this.dateError = null;
        }
        this.showReport = true;
        this.filterStartDate = this.startDate;
        this.filterEndDate = this.endDate;
        if (this.period.value !== this.customValue) {
            this.fileName = this.period.label;
        } else {
            this.fileName = `${this.startDate}-${this.endDate}`;
        }
    }

    onPeriodValueChanged(item: DropdownValue) {
        this.resetDatePickers();
        this.showCustomPeriod = true;
        this.startDate = this.filterItemsService.getMinValueSelected(item.value);
        this.endDate = this.filterItemsService.getMaxValueSelected(item.value);
        //if not custom value to be selected manually, set the dates from the period in the datepickers
        if (item.value !== this.customValue) {
            this.setDateInDatePicker();
        }
        this.period = item;
        this.dropdownComponent.setCurrentSelection(this.period);
    }

    private setDateInDatePicker() {
        let startDatePicker = this.el.nativeElement.querySelectorAll("input.start-date-input");
        let endDatePicker = this.el.nativeElement.querySelectorAll("input.end-date-input");
        $(startDatePicker).val(this.dateHelperService.formatDayAndMonth(this.startDate));
        $(endDatePicker).val(this.dateHelperService.formatDayAndMonth(this.endDate));
    }

    onclickedRecentReport(report: IRecentSavedReportModel) {
        if (report) {
            this.reportSelected = true;
            this.selectedType = report.type;
            this.showReport = true;
            this.showCustomPeriod = true;
            this.startDate = report.startDate;
            this.endDate = report.endDate;
            this.filterStartDate = this.startDate;
            this.filterEndDate = this.endDate;
            this.defaultPeriodSelection = this.periodValues.find(s => s.value === this.customValue);
            this.period = this.defaultPeriodSelection;
            this.fileName = `${this.dateHelperService.formatDayAndMonth(this.startDate)}-${this.dateHelperService.formatDayAndMonth(this.endDate)}`;
            this.dropdownComponent.setCurrentSelection(this.period);
        }
    }

    public onDateClicked(event) {
        let ng2datePicker = this.el.nativeElement.querySelectorAll("ng2-datetime-picker[draggable='true']");
        $(ng2datePicker).attr('draggable', 'false');
    }

    private resetDatePickers() {
        this.showCustomPeriod = false;
        this.startDate = null;
        this.endDate = null;
        this.dateError = null;
        let datePickers = this.el.nativeElement.querySelectorAll("[data-datepicker]");
        if (this.browserSerive.isIE())
            datePickers = [datePickers];
        if (datePickers) {
            datePickers.forEach(element => {
                element.value = '';
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts